import PAYMENT_METHOD_TYPES from './payment-method-types-enum';

TripCheckoutPaymentService.SERVICE_NAME = 'tripCheckoutPaymentService';

export default function TripCheckoutPaymentService() {

    return {
        isPaymentMethodInvoice,
    };

    function isPaymentMethodInvoice(paymentMethods = []) {
        return paymentMethods.some((method) => method.Type === PAYMENT_METHOD_TYPES.INVOICE);
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/payment/trip-checkout-payment-service.js